var _a;
import { __decorate, __metadata } from "tslib";
import { Module, VuexModule, Action } from 'vuex-module-decorators';
import { dynamicSort } from '@/core/helpers/table-sort';
import ApiService from '@/core/services/ApiService';
import { Actions } from '@/store/enums/hrgs/AnswerTypeEnum';
import { ElMessage } from 'element-plus';
const API_URL = `${process.env.VUE_APP_BASE_URL_DIGITAL}/${process.env.VUE_APP_MOBA_WEBAPI}`;
const API_URLS = {
    getAll: `${API_URL}/api/answertypes`
};
let AnswerTypeModule = class AnswerTypeModule extends VuexModule {
    // *ACTIONS
    [_a = Actions.GET_ANSWER_TYPE]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const url = `${API_URLS.getAll}/${employeeID}?`;
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${url}${new URLSearchParams(params).toString() || ''}`)
                .then((data) => {
                const resData = data.data.result.content.sort(dynamicSort('code', 'descending'));
                resolve(resData);
            })
                .catch((error) => {
                reject(error);
            });
        });
    }
};
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AnswerTypeModule.prototype, _a, null);
AnswerTypeModule = __decorate([
    Module
], AnswerTypeModule);
export default AnswerTypeModule;
